module.exports = __webpack_public_path__ + "static/media/tpn-ce-sketches.10c6aa06.jpg";